import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Users, FileText, DollarSign, AlertTriangle } from 'lucide-react';
import api from '../services/api';

const StatCard = ({ title, value, icon: Icon, color }) => (
  <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm font-medium text-gray-500">{title}</p>
        <p className="text-2xl font-bold text-gray-900 mt-1">{value}</p>
      </div>
      <div className={`p-3 rounded-lg ${color}`}>
        <Icon size={24} className="text-white" />
      </div>
    </div>
  </div>
);

export default function Dashboard() {
  const { data: stats, isLoading } = useQuery({
    queryKey: ['stats'],
    queryFn: async () => {
      const response = await api.get('/dashboard/stats');
      return response.data;
    },
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
        <p className="text-gray-500">Bienvenido a PilarNet</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard
          title="Clientes Activos"
          value={stats?.totalClientes || 0}
          icon={Users}
          color="bg-blue-500"
        />
        <StatCard
          title="Facturas Pendientes"
          value={stats?.facturasPendientes || 0}
          icon={FileText}
          color="bg-yellow-500"
        />
        <StatCard
          title="Ingresos Totales"
          value={`$${(stats?.ingresosTotales || 0).toLocaleString('es-AR')}`}
          icon={DollarSign}
          color="bg-green-500"
        />
        <StatCard
          title="Deuda Total"
          value={`$${(stats?.deudaTotal || 0).toLocaleString('es-AR')}`}
          icon={AlertTriangle}
          color="bg-red-500"
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Resumen</h2>
          <div className="space-y-3">
            <div className="flex justify-between py-2 border-b border-gray-50">
              <span className="text-gray-600">Total Facturas</span>
              <span className="font-medium">{stats?.totalFacturas || 0}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-gray-50">
              <span className="text-gray-600">Facturas Vencidas</span>
              <span className="font-medium text-red-600">{stats?.facturasVencidas || 0}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
